<template>
  <el-container class="process-form-design">
    <div class="aside">
      <div class="component-aside" width="240px">
        <div class="process-form-panel">
          <component :ref="leftPanel" :is="leftPanel" :originalComponent="currentComponent" :highlightId="highlightId" :currentNodeFormId="currentNodeFormId"></component>
        </div>
      </div>
    </div>
    <el-main>
      <slot name="form"></slot>
      <slot name="process"></slot>
      <rc-form v-if="form" :component="form" :selectId="selectId" :highlightId="highlightId" :nodeIsCountersign="nodeIsCountersign" :processSaveState="processSaveState"></rc-form>
      <slot name="formButtons"></slot>
    </el-main>
  </el-container>
</template>

<script>
import ComponentList from '@/components/form/design/component-list.vue'
import ComponentAttr from '@/components/form/design/component-attr.vue'
import RcForm from '@/components/form/components/form/rc-form.vue'
import Vue from 'vue'
import {FormComponent, ProcessComponent} from '@/store/form/component'
export default {
  name: 'ComponentDesign',
  props: ['form', 'nodeIsCountersign', 'currentNodeFormId', 'processSaveState'],
  provide: {
    componentEventBus: new Vue()
  },
  inject: ['formService'],
  data () {
    return {
      leftPanel: 'ComponentList',
      currentComponent: {},
      selectId: '',
      highlightId: ''
    }
  },
  mounted () {
    this._provided.componentEventBus.$on('changeLeftPanel', this.change)
    this._provided.componentEventBus.$on('highlightLayout', this.highlightLayout)
  },
  watch: {
    currentNodeFormId (val, oldVal) {
      // 流程切换节点时重置高亮控件
      if (val !== oldVal) {
        this.highlightId = ''
      }
    }
  },
  components: {
    ComponentList,
    ComponentAttr,
    RcForm
  },
  methods: {
    change (val) {
      // 明明new的是不同实例 但是当打开了表单和流程设计页会导致表单和流程公用同一个 componentEventBus
      // 根据formService.component类型判断是流程还是表单
      let href = window.location.href
      if (this.formService.component instanceof FormComponent) {
        if (!href.includes('form-design-list')) return false
      } else if (this.formService.component instanceof ProcessComponent) {
        if (!href.includes('process-design-list')) return false
      }
      if (val.state !== 'ComponentList') {
        this.leftPanel = 'ComponentAttr'
        let newCurrent = this.$_.cloneDeep(this.formService.getComponentById(val.id))
        if (this.$refs.ComponentAttr && this.currentComponent && Object.keys(this.currentComponent).length && JSON.stringify(this.$refs.ComponentAttr.component) !== JSON.stringify(this.currentComponent)) {
          this.$message.info('请先保存当前控件的属性')
        } else {
          this.currentComponent = newCurrent
          this.selectId = val.id
        }
      } else {
        if (val.id === 'null') {
          this.leftPanel = 'ComponentList'
          this.currentComponent = {}
          this.selectId = ''
        } else if (this.currentComponent && val.id === this.currentComponent.id) {
          this.leftPanel = 'ComponentList'
          this.currentComponent = {}
          this.selectId = ''
        } else if (this.currentComponent && val.id !== this.currentComponent.id) {
          this.selectId = val.id
          // 删除控件时,如果该控件属性面板打开,则关闭
          return false
        }
      }
    },
    highlightLayout (val) {
      if (val.state === 'layout') {
        this.highlightId = val.id
      }
    }
  }
}
</script>
<style lang="scss">
.process-form-design {
  height: calc(100% - 45px);
  background: #f8fbfe;
  margin-top: 8px;
  .aside {
    width: 242px;
    min-width: 242px;
    float: left;
    height: 100%;
    font-size: 12px;
    background: #fff;
    position: relative;
    .component-attr {
      margin-top: 12px;
      padding-top: 40px;
      height: calc(100% - 12px);
    }
    .component-aside {
      width: 100%;
      height: 100%;
      margin: 0 8px;
      border: 1px solid #c2c3c4;
      border-radius: 4px;
      background: #fff;
      overflow: auto;

      .el-input {
        width: 100%;
      }
      .component-attr .el-form-item {
        position: relative;
        margin: 14px 0;
        .el-form-item__label {
          font-size: 12px;
          padding: 0;
        }
      }
      .el-tabs {
        position: absolute;
        background: #ebf6ff;
        top: 1px;
        width: 240px;
        border-radius: 4px;
        z-index: 10;
        .el-tabs__header {
          margin-bottom: 0;
        }
        .el-tabs__item {
          padding: 0;
        }
      }
      .el-checkbox {
        margin-top: -16px;
        position: absolute;
        top: 50%;
        right: 0;
      }
      .el-switch {
        margin-top: -10px;
        position: absolute;
        top: 50%;
        right: 0;
      }
    }
  }
  .el-main {
    float: left;
    margin-left: 12px;
    width: calc(100% - 300px);
    height: 100%;
    padding: 16px 28px 0 18px;
    background: #fff;
    .component-title {
      padding-left: 10px;
    }
    .first {
      margin-left: 10px;
      position: relative;
      display: inline-block;
      &::before {
        content: "";
        width: 2px;
        height: 14px;
        background: #54abf1;
        position: absolute;
        left: -10px;
        top: 3px;
      }
    }
    .design-buttons {
      text-align: center;
      margin-top: 40px;
      overflow: auto;
      white-space: nowrap;
      .el-button {
        height: 26px;
        padding: 5px 9px;
      }
      .tooltip {
        color: #b3d8ff;
      }
    }
  }
  .buttons {
    padding-top: 5px;
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/design/component-design.vue